import { Validator } from '../../types/Validator';
import { ValidatorInterface } from '../../types/ValidatorInterface';
import { ValidatorRegistry } from '../../types/ValidatorRegistry';
import { PropertiesInterface } from '../../types/properties/Property';
import { ITypeValidatesRequired } from './ITypeValidatesRequired';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use RequiredValidator from application-types instead.
 */
export class RequiredValidator
  implements ValidatorInterface<ITypeValidatesRequired> {
  name = 'Required';

  friendlyName = 'Required Field';

  arrayOnly = false;

  array = true;

  description = 'shared.properties.validators.required.description';

  types = null;

  properties = {
    value: {
      type: 'Boolean',
      default: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  attach(type: ITypeValidatesRequired) {
    type.addRequiredValidator(this);
  }

  constructor(public config?: Validator) {}
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Required from application-types instead.
 */
const Required: ValidatorInterface<ITypeValidatesRequired> = new RequiredValidator(
  undefined
);

ValidatorRegistry.register(RequiredValidator, Required.name);

export default Required;
